import React, { useEffect, useState } from 'react';
import useCurrentUser from '../hooks/useCurrentUser';
import { EUserType } from '../data_models/enums';
import useRouting from '../hooks/useRouting';
import FreelancerUserProfile from '../components/profile/freelancer/FreelancerUserProfile';
import EmployerUserProfile from '../components/profile/employer/EmployerUserProfile';
import { useSearchParams } from 'react-router-dom';
import useUser from '../hooks/useUser';
import { IFreelancer } from '../data_models/freelancer';
import { IEmployer } from '../data_models/employer';
import LoadingIndicator from '../components/common/LoadingIndicator';
import useDisplayNotifications from '../hooks/useDisplayNotifications';
import { DisplayNotificationType } from '../models/DisplayNotification';
import useGlobalLoading from '../hooks/useGlobalLoading';

const UserProfilePage: React.FC = () => {

    const [searchParams] = useSearchParams();
    const type = searchParams.get('type') || '';
    const userId = searchParams.get('id') || '';

    const [user, setUser] = useState<IFreelancer | IEmployer | undefined>(undefined);
    const { currentUser, currentUserType, fetchCurrentUser } = useCurrentUser();

    const [isCurrentUser, setIsCurrentUser] = useState(false);

    const { fetchEmployerById,
        fetchFreelancerById
    } = useUser();
    const { goTo404 } = useRouting();
    const { addNotification } = useDisplayNotifications();
    const { setLoading } = useGlobalLoading();

    useEffect(() => {
        setUser(undefined);
    }, [userId, type]);

    useEffect(() => {
        if (!type || !userId) {
            goTo404();
            return;
        }

        const fetchUser = async () => {
            try {
                if (type === EUserType.FREELANCER) {
                    const freelancer = await fetchFreelancerById(userId);
                    setUser(freelancer);
                } else if (type === EUserType.EMPLOYER) {
                    const employer = await fetchEmployerById(userId);
                    setUser(employer);
                } else {
                    goTo404();
                }
            } catch (error) {
                addNotification({
                    message: 'Internal Error - User not found',
                    type: DisplayNotificationType.ERROR
                }, true);
                goTo404();
            }
        };

        fetchUser();
    }, [userId, type]);

    useEffect(() => {
        if (currentUserType && currentUser && currentUser._id && currentUser._id === userId && currentUserType === type) {
            setIsCurrentUser(true);
        } else {
            setIsCurrentUser(false);
        }
    }, [currentUser, currentUserType, userId, type])

    useEffect(() => {
        if (isCurrentUser) {
            setLoading(true);
            fetchCurrentUser().then(() => {
            }).finally(() => {
                setLoading(false);
            });
        }
    }, [isCurrentUser])

    return (
        <div key={`${type}-${userId}`}>
            {!user || (!currentUser && isCurrentUser)
                ? <div className='flex flex-col items-center w-full my-10'>
                    <LoadingIndicator theme='primary' />
                </div>
                : type === EUserType.FREELANCER
                    ? <div><FreelancerUserProfile isCurrentUser={isCurrentUser} freelancer={user as IFreelancer} />
                    </div>
                    : type === EUserType.EMPLOYER
                        ? <div>
                            <EmployerUserProfile employer={user as IEmployer} isCurrentUser={isCurrentUser} />
                        </div>
                        : <div>
                            <h1>Invalid Url</h1>
                        </div>}

        </div>
    );
};

export default UserProfilePage;